import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import useReactRouterBreadcrumbs from 'use-react-router-breadcrumbs'
import { TabContext, TabList } from '@mui/lab'
import { Box, Container, Tab } from '@mui/material'
import type { SidebarMenuProps } from 'modules/types'
import TabStyle from './style'

const Tabs = ({ tabs }: { tabs?: SidebarMenuProps[] }) => {
  const navigate = useNavigate()
  const breadcrumbs = useReactRouterBreadcrumbs()
  const current = tabs && tabs.find((list) => breadcrumbs.some((bread) => list.path == bread.key))
  const selectedIndex = current && tabs ? tabs.indexOf(current) : -1
  const selectedTab = selectedIndex >= 0 ? selectedIndex.toString() : ''

  const changeTab = (_: React.SyntheticEvent, value: string) => {
    if (tabs) navigate(tabs[+value].path)
  }

  useEffect(() => {
    if (tabs?.length && selectedIndex < 0) navigate(tabs[0].path, { replace: true })
  }, [navigate, selectedIndex, tabs])

  return (
    <Container {...TabStyle.Container}>
      <TabContext value={selectedTab}>
        <Box {...TabStyle.Tab}>
          {current && selectedIndex >= 0 && (
            <TabList onChange={changeTab}>
              {tabs &&
                tabs.map((tab, index) => (
                  <Tab label={tab.name} key={index} value={index.toString()} />
                ))}
            </TabList>
          )}
        </Box>
      </TabContext>
    </Container>
  )
}

export default Tabs
